import React from 'react';
import { GraduationCap, MapPin, FileCheck, Award, Compass, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: Compass,
      title: 'Career Counseling',
      description: 'Feeling stuck with too many options? Let\'s cut through the noise and discover what really lights you up.'
    },
    {
      icon: GraduationCap,
      title: 'Course Selection',
      description: 'Not sure which program fits? We\'ll help you choose one that aligns with your goals and sets you up for success.'
    },
    {
      icon: MapPin,
      title: 'University Shortlisting',
      description: 'Too many universities, too little time? We\'ll help you shortlist the best universities in Dubai that match your profile and aspirations.'
    },
    {
      icon: FileCheck,
      title: 'Application Assistance',
      description: 'Stressed about SOPs, LORs, and paperwork? We will handle it all - hassle-free application process guaranteed.'
    },
    {
      icon: Award,
      title: 'Scholarship Guidance',
      description: 'Curious which scholarships you qualify for? We make it easy to find and secure scholarships so you can earn a top international degree without the financial burden.'
    },
    {
      icon: Users,
      title: 'Visa & Documentation',
      description: 'Confused by visa forms and documents? We take care of everything, making your journey smooth and stress-free.'
    }
  ];

  return (
    <>
      <section id="services" className="services-section">
        <div className="services-container">
          <div className="services-content-wrapper">
            <div className="services-text-content">
              <div className="services-header">
                <h2 className="section-title">How we turn dreams into reality</h2>
              </div>

              <div className="services-grid">
                {services.map((service, index) => (
                  <Card key={index} className="service-card">
                    <CardContent className="service-card-content">
                      <div className="service-icon">
                        <service.icon size={32} />
                      </div>
                      <h3 className="service-title">{service.title}</h3>
                      <p className="service-description">{service.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
            <div className="services-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_dubai-education/artifacts/wdyobfe8_personal%20goals%20checklist-bro.png" 
                alt="Student planning study abroad goals with education counselor guidance and checklist"
                className="services-illustration"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="wave-divider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#9fe2ff"></path>
        </svg>
      </div>
    </>
  );
};

export default Services;